
import Vue from 'vue';
import { Data as ArticleData } from '@root/modules/article/types/article';
import LinkHandler from '@core/components/helpers/LinkHandler.vue';

interface Props {
  article: ArticleData;
}

interface Computed {
  links: Array<any>;
}

export default Vue.extend<unknown, unknown, Computed, Props>({
  components: {
    LinkHandler,
  },
  props: {
    article: {
      type: Object,
      required: true,
    },
  },
  computed: {
    links() {
      const links: any[] = [];
      const { locale } = this.$channelConfig('settings');
      let categoryLinkPosition = 2;

      // Get channel link
      const channelSlug = this.$channelConfig('settings').id !== 'delfi' ? `/${this.$channelConfig('settings').id}` : `/`;
      links.push({ name: this.article.primaryCategory.channel.name, href: channelSlug, position: 1 });

      // Get parent category link
      // FIXME: could be channelConfig.external_id int to get rid of this .toString()?
      const parentCategory = this.article.primaryCategory.parentCategory || null;
      if (parentCategory && parentCategory.id && parentCategory.id.toString() !== this.$channelConfig('settings').externalId) {
        const parentCategoryUrl = this.$options.filters!.categoryUrl({ category: parentCategory, locale });
        links.push({ name: parentCategory.name, href: parentCategoryUrl, position: categoryLinkPosition });
        categoryLinkPosition += 1;
      }

      // Get category link
      const categoryUrl = this.$options.filters!.categoryUrl({ category: this.article.primaryCategory, locale });
      links.push({ name: this.article.primaryCategory.name, href: categoryUrl, position: categoryLinkPosition });

      return links;
    },
  },
});
